import React, { useState, useRef, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { withTranslation } from "react-i18next";

const ProductIngredientInputForm = (props) => {
    let componentData = props.componentData; // layout service data
    let productIngredientData = props.productIngredientInputData; // parent prop to take inputs
    const { t } = props; // for dictionary phrases

    const [brand, setBrandName] = useState(""); // Start with no selection
    const [productId, setProductId] = useState("");
    const [expandBrandsDropdown, setExpandBrandsDropdown] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    
    const wrapperRefWeightUnit = useRef(null);

    useEffect(() => {
            productIngredientData(
                brand,
                productId
            );
        }, [
            brand,
            productId
        ]);  

    //To update and use this for button validation
    useEffect(() => {
        //to proceed with API call considering at least one input
        if (brand != "" || productId != "") 
        {
            setIsValidated(true);
        } 
        else {
            setIsValidated(false)
        }
        if(isValidated) {
            document.getElementById("btn-calculate").disabled = false;
        } else {
            document.getElementById("btn-calculate").disabled = true;
        }
    }, [brand, productId]);

    const toggleBrandDowndown = () => {
        expandBrandsDropdown ? setExpandBrandsDropdown(false) : setExpandBrandsDropdown(true);
    };

    return (
        <div className="row mx-md-3">
            <div className={isMobile ? "col-12" : "col-md-6 col-sm-12"}>
                <div className="form-group">
                    <label htmlFor="selectedBrandName">
                        Select a Brand
                    </label>
                    <div className="brand-select">
                        <div className="custom-select-dropdown">
                            <div className="select-box--box">
                                <div className="select-box--container">
                                    <div
                                        className="select-box--selected-item"
                                        onClick={toggleBrandDowndown}
                                        ref={wrapperRefWeightUnit}
                                    >
                                        <div 
                                            className={
                                                !expandBrandsDropdown
                                                    ? "select-box-selected-item-text-div"
                                                    : "select-box-selected-item-text-div-close"
                                            }
                                        >
                                            <span
                                                style={{
                                                    textTransform: "capitalize",
                                                    color: brand ? "#212529" : "#aaa" // Gray if no selection
                                                }}
                                                className="select-box-selected-item-text"
                                            >
                                                {brand || "Select a Brand"}
                                            </span>
                                        </div>
                                        <div
                                            className="select-box--arrow"
                                            name="select-box--name"
                                        >
                                            <span
                                                name="drop-down-arrow"
                                                className={`${
                                                    expandBrandsDropdown
                                                        ? "select-box--arrow-up fa fa-angle-up"
                                                        : "select-box--arrow-down fa fa-angle-down"
                                                }`}
                                            ></span>
                                        </div>
                                    </div>
                                    <div 
                                        style={{
                                            display: expandBrandsDropdown
                                                ? "block"
                                                : "none",
                                        }}
                                        className="select-box--items"
                                    >
                                        {componentData?.Brands?.map((item, index) => {
                                            return (
                                                <div
                                                    className={
                                                        brand === item.fields?.key?.value
                                                            ? "select-div selected"
                                                            : "select-div"
                                                    }
                                                    key={index}
                                                    onClick={() => {
                                                        setBrandName(item.fields?.key?.value);
                                                        setExpandBrandsDropdown(false); // Close dropdown after selection
                                                    }}
                                                >
                                                    <p className="nameListItem">
                                                        {item.fields.key.value}
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={isMobile ? "col-12" : "col-md-6 col-sm-12"}>
                <div className="form-group">
                    <label htmlFor="productId">
                    Enter Product ID
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="productId"
                        placeholder="105593300,105593200"
                        value={productId}
                        onChange={(e) => setProductId(e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(ProductIngredientInputForm);